<template>
  <section class="oas">
    <div class="oas-item" v-for="(oa, index) in getOas" :key="index">
      <a v-if="oasAtributes['img']" :href="'../oa/' + oa.id">
        <div class="card-content">
          <img src="../assets/Icon.png" alt="Logo do Baobah" />
        </div>
      </a>
      <section class="card-footer">
        <div class="card-footer-content">
          <div class="tags">
            <div class="tags-oas">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              ></svg>
              <p>{{ oa.author }}</p>
            </div>
          </div>
          <!-- <button class="custom-checkbox"></button> -->
        </div>
        <div class="card-title">
          <h3>{{ oa.title }}</h3>
        </div>
        <a class="acesse" :href="'../oa/' + oa.id">
          <p>Acesse</p>
          <img src="../assets/icon-arrow-up-right.png" alt="" />
        </a>
      </section>
    </div>
  </section>
</template>

<script>
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";

export default defineComponent({
  name: "MyCards",
  props: {
    oasAtributes: {
      required: false,
      type: Map,
      default: () => ({
        title: true,
        author: true,
        img: true,
        description: false,
      }),
    },
  },
  methods: {
    ...mapActions(["AgetOas"]),
  },
  mounted() {
    this.AgetOas();
  },
  computed: {
    ...mapGetters({
      oas: "getOas",
    }),
    getOas() {
      return this.oas;
    },
  },
});
</script>

<style scoped lang="css">
* {
  margin: 0px;
  padding: 0px;
  color: white;
  --swiper-theme-color: transparent;
}
.oas {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.oas-item {
  display: flex;
  flex-direction: column;
  width: 350px;
  height: auto;
  padding: 20px;
}

.card-content {
  background-color: var(--silver-medal);
  height: 200px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-footer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  color: white;
  background-color: var(--orange, #da372e);
  border-bottom: 2px solid var(--orange, #da872e);
  border-end-start-radius: 4px;
  border-end-end-radius: 4px;
}

.card-footer-content {
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}

.tags {
  display: flex;
  width: 90%;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
}

.tags-oas {
  display: flex;
  align-items: center;
  background-color: var(--yellow);
  padding: 5px 10px;
  border-radius: 20px;
}

.card-title {
  padding-left: 16px;
  padding-bottom: 15px;
}

.card-title h2 {
  color: var(--white, #fff);
  font-size: 32px;
  font-weight: 700;
}

.custom-checkbox {
  width: 20px;
  height: 20px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  background-image: url("../assets/icon-heart-white.png");
}

.acesse {
  padding: 16px;
  padding-top: 0px;
  color: var(--white);
  text-decoration: none;
  display: flex;
  gap: 5px;
}
</style>
